import { CHAIN_INFO_LIST, CHAIN_SUPPORTS_WITHDRAW_ST_TOKEN } from '@/config'
import type { MsgTransfer } from 'cosmjs-types/ibc/applications/transfer/v1/tx'
import { MetaDataHandlerParameters } from './types'

const handleIbcWithdrawStToken = ({
  message,
  strideAddress,
  selectedAddress,
  denom
}: MetaDataHandlerParameters<MsgTransfer>): boolean => {
  if (!CHAIN_SUPPORTS_WITHDRAW_ST_TOKEN[denom]) {
    return false
  }

  if (message.token == null) {
    return false
  }

  if (!message.token.denom.startsWith('st')) {
    return false
  }

  const isStTokenTransferredFromStrideToChain =
    message.sender === strideAddress &&
    message.receiver === selectedAddress &&
    message.token.denom === `st${CHAIN_INFO_LIST[denom].stakeCurrency.coinMinimalDenom}`

  return isStTokenTransferredFromStrideToChain
}

export { handleIbcWithdrawStToken }
